module.exports = __webpack_public_path__ + "img/filter-type-lowerbody.5916d44f.svg";